export const MENSAJES_ERROR = {
    AUTH_CREDENCIALES_INVALIDAS: 'Usuario o contraseña incorrectos.',
    AUTH_USUARIO_INACTIVO: 'El usuario no está activo.',
    AUTH_USUARIO_BLOQUEADO: 'El usuario está bloqueado. Intentá más tarde.',
    AUTH_TOKEN_EXPIRADO: 'Tu sesión expiró. Ingresá de nuevo.',
    AUTH_TOKEN_INVALIDO: 'Sesión inválida. Ingresá de nuevo.',
    AUTH_SIN_PERMISO: 'No tenés permisos para esta acción.',
    VALIDACION: 'Revisá los campos marcados.',
    RESERVA_NO_ENCONTRADA: 'La reserva no existe o fue eliminada.',
    RESERVA_CANCELADA: 'La reserva está cancelada.',
    CLASE_SUPERPUESTA: 'El instructor ya tiene otra clase en ese horario.',
    CLASE_EMPLEADO_SIN_HABILITACION: 'El instructor no está habilitado para esta disciplina.',
    PAGO_MONTO_INVALIDO: 'El monto ingresado no es válido.',
    PAGO_YA_REVERSADO: 'Este pago ya fue reversado.',
    INTERNO_DESCONOCIDO: 'Ocurrió un error inesperado. Reintentá.',
    NETWORK: 'No pudimos conectar con el servidor. Verificá tu conexión.',
};
export function mensajeParaCodigo(codigo) {
    if (!codigo)
        return MENSAJES_ERROR.INTERNO_DESCONOCIDO;
    return MENSAJES_ERROR[codigo] ?? MENSAJES_ERROR.INTERNO_DESCONOCIDO;
}
